module.exports = function() {
    return (navigator && navigator.userAgent || '').toLowerCase();
};